import React, { useEffect, useState } from 'react';
import { utils, writeFile } from 'xlsx';
import styles from './index.module.scss';
import dateformat from 'dateformat';
import { useStore, StoreTypes } from 'context';
import { Button, Typography, Divider, makeStyles,TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,TablePagination  } from '@material-ui/core';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import RefreshIcon from '@material-ui/icons/Refresh';
import Icon from "components/Icon";
import Loading from "components/Loading";

const tableContainerStyles = makeStyles({
  root: {
    "& .MuiTableCell-stickyHeader": {
      padding: "8px 16px",
      fontSize: "16px",
      color: "#637381",
      borderBottom: "0px",
      userSelect: "none",
      "&:nth-child(1)": {
        borderRadius: "8px 0px 0px 8px",
      },
      "&:last-child": {
        borderRadius: "0px 8px 8px 0px",
      },
      "& span": {
        cursor: "pointer",
        "& svg": {
          fontSize: "12px",
        },
      },
    },
    "& .MuiTableCell-body": {
      borderBottom: "0px",
      padding: "0px 16px",
      height: "56px",
    },
  },
});



const resultButtonStyles = makeStyles({
  root: {
    height: "36px",
    width: "120px",
    minWidth: "88px",
    color: "white",
    background: "#315D83",
    fontSize: "14px",
    fontWeight: "700",
    boxShadow: "none",
    "&:disabled": {
      background: "lightGrey",
    },
    "&:hover": {
      background: "#4786bb",
    },
  },
});

const refreshButtonMakeStyles = makeStyles({
  root: {
    height: "30px",
    width: "72px",
    minWidth: "88px",
    color: "#212B36",
    background: "#74CAFF",
    fontSize: "14px",
    fontWeight: "700",
    boxShadow: "none",
    borderRadius: "8px",
    "&:disabled": {
      background: "lightGrey",
    },
    "&:hover": {
      background: "#74CAFF",
    },
  },
});

const actionButtonMakeStyles = makeStyles({
  root: {
    height: "36px",
    width: "116px",
    minWidth: "88px",
    color: "#212B36",
    background: "#FFD285",
    fontSize: "14px",
    fontWeight: "700",
    boxShadow: "none",
    borderRadius: "8px",
    "&:disabled": {
      background: "lightGrey",
    },
    "&:hover": {
      background: "#FFD285",
      boxShadow: "none",

    },
  },
});

const backButtonMakeStyles = makeStyles({
  root: {
    height: "36px",
    width: "130px",
    minWidth: "88px",
    color: "#315D83",
    background: "#FFFFFF",
    fontSize: "14px",
    fontWeight: "700",
    boxShadow: "none",
    borderRadius: "8px",
    border: '1px solid #315D837A',
    "&:disabled": {
      background: "lightGrey",
    },
    "&:hover": {
      background: "#FFFFFF",
      boxShadow: "none",

    },
  },
});

function difficultyName(difficulty) {
  if(difficulty === -1) {
    return '';
  }
  if(difficulty === 0) {
    return '基礎';
  }
  if(difficulty === 1) {
    return '進階';
  }
  return '挑戰';
}

function getTimeFormat(time) {
  const minutes = Math.floor(time / 1000 / 60);
  const seconds = Math.floor(time / 1000) % 60;
  return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
}

export default function ExamStudentList() {

  const [{ token }] = useStore(StoreTypes.user);
  
  const tableStyles = tableContainerStyles();
  const buttonStyles = resultButtonStyles();
  const refreshButtonStyles = refreshButtonMakeStyles();
  const actionButtonStyles = actionButtonMakeStyles();
  const backButtonStyles = backButtonMakeStyles();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [sort, setSort] = useState('desc');
  const [info, setInfo] = useState({
    averageTime: 0,
    averageScore: 0,
    userIds: [],
    examName: "",
    createdAt: ""
  });
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [difficulty, setDifficulty] = useState(-1);
  const [pageRange, setPageRange] = useState('');
  const [loading, setLoading] = useState(true);
  
  const updateTime = dateformat(Date.now(), 'yyyy/mm/dd HH:MM')
  const formattedAverageTime = getTimeFormat(info.averageTime);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tempPageRange = params.get('pageRange');
    const tempDifficulty = params.get('difficulty');
    setPageRange(tempPageRange);
    setDifficulty(parseInt(tempDifficulty));
  }, []);

  const getList = async () => {

    const params = new URLSearchParams(window.location.search);
    const quizId = params.get('quizId');
    const quizCode = params.get('quizCode');
    const schoolYear = params.get('schoolYear');
    const examType = params.get('examType');

    let newParams = new URLSearchParams({ 
      schoolYear,
      quizCode,
      type: examType
    });

    let dataParams = new URLSearchParams({
      quizId,
      skip: page * limit,
      limit,
      sort,
      type: examType
    });

    fetch(`${process.env.REACT_APP_API_DOMAIN}/exams/examDetail?${newParams.toString()}`, {
      method: 'GET',
      headers: {
        'Authorization': token
      }
    }).then((res) => { 
      return res.json()
    }).then((res) => {
      setInfo({
        averageTime: 0,
        averageScore: 0,
        ...res.data});
    }).finally(() => {
      setLoading(false);
    });

    fetch(`${process.env.REACT_APP_API_DOMAIN}/exams/studentResults?${dataParams.toString()}`, {
      method: 'GET',
      headers: {
        'Authorization': token
      }
    }).then((res) => { 
      return res.json()
    }).then((res) => {
      setData(res.data.studentResults);
      setTotal(res.data.total);
    })

  }

  useEffect(() => {
    if(token) {
      getList();
    }
  }, [page, limit, sort, token]);

  const toReviewExam = () => {

    const params = new URLSearchParams(window.location.search);
    const schoolYear = params.get('schoolYear');
    const quizId = params.get('quizId');
    const quizCode = params.get('quizCode');
    const examType = params.get('examType');

    if(examType === 'paper') {
      window.open(
        `https://oneexam.oneclass.com.tw/quiz/review/${schoolYear}/${quizCode}/${quizId}`,
        '_blank'
      );
    } else {
      window.open(
        `${process.env.REACT_APP_ONE_EXAM_RESULT_URL}/quiz/review/${schoolYear}/${quizCode}/${quizId}`,
        '_blank'
      );
    }

  }

  const toExamRecord = (item) => {
    const params = new URLSearchParams(window.location.search);
    const schoolYear = params.get('schoolYear');
    const quizCode = params.get('quizCode');
    const examType = params.get('examType');

    if(examType === 'paper') {
      window.open(
        `https://oneexam.oneclass.com.tw/${quizCode}/${schoolYear}/${item.seatNo}/${item.userName}`,
        '_blank'
      );
    } else {
      window.open(
        `${process.env.REACT_APP_ONE_EXAM_RESULT_URL}/${quizCode}/${schoolYear}/${item.seatNo}/${item.userName}`,
        '_blank'
      );
    }
  }

  const backToExamList = () => {
    const params = new URLSearchParams(window.location.search);
    const preparationId = params.get('preparationId');
    const bookId = params.get('bookId');
    const tempPageIndex = params.get('pageIndex');
    const tempPageRange = params.get('pageRange');

    window.location.href = `/examlist?preparationId=${preparationId}&bookId=${bookId}&pageIndex=${tempPageIndex}&pageShow=${tempPageRange}`;
  }

  const iconName = () => {
    if (sort === 'asc') {
      return 'arrowUp';
    } else if (sort === 'desc') {
      return 'arrowDown';
    }
  }

  const handleSort = () => {
    if(sort === 'asc') {
      setSort('desc');
    }
    if(sort === 'desc') {
      setSort('asc');
    }
  }

  const exportExcel = async () => {
    const excelData = [['派出時間', '座號', '姓名', '花費時長', '成績']];

    const params = new URLSearchParams(window.location.search);
    const quizId = params.get('quizId');
    const examType = params.get('examType');

    let dataParams = new URLSearchParams({
      quizId,
      skip: 0,
      limit: total,
      sort: 'desc',
      type: examType
    });

    const response = await fetch(`${process.env.REACT_APP_API_DOMAIN}/exams/studentResults?${dataParams.toString()}`, {
      method: 'GET',
      headers: {
        'Authorization': token
      }
    });
    const json = await response.json();
    json.data.studentResults.forEach((item) => {
      const time = getTimeFormat(item.sumTime);
      const score = item.userTotalScore;
      excelData.push([dateformat(item.createdAt, 'yyyy/mm/dd HH:MM'), item.seatNo, item.userName, time, score]);
    })

    const sheet = utils.aoa_to_sheet(excelData);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, sheet, '成績表');

    writeFile(
      workbook,
      `${info.examName}.xlsx`,
      {
        compression: true,
      },
    );
  };


  return (
    <div>
    <div className={styles.header}>
      <div className={styles.container}>
        <img className="logo" src="img/logo.svg" alt="onebook" />
      </div>
    </div>
    {
      loading && <Loading />
    }
    {
      !loading && <div className={styles.mainBg}>
      <div className={styles.container}>

        <div className={styles.action}>
          <div className={styles.actionBlock}>
            <Button classes={backButtonStyles} variant="contained" color="primary" onClick={backToExamList}><KeyboardArrowLeftIcon />返回上一頁</Button>
            <div className={styles.examName}>{ info.examName }</div>
          </div>
          <div className={styles.actionBlock}>
            <Button classes={actionButtonStyles} variant="contained" color="primary" startIcon={<img src='img/review.svg' />}
            onClick={toReviewExam}>檢討測驗</Button>
            <Button classes={actionButtonStyles} variant="contained" color="primary"  startIcon={<img src='img/download.svg' />} onClick={exportExcel}>匯出成績</Button>
          </div>
        </div>


        <div className={styles.block}>
          <div className={styles.info}>
            <div className={styles.examInfo}>
              <div>
                派出時間： {dateformat(info.createdAt, 'yyyy/mm/dd HH:MM')}
              </div>
              <div>
                派出範圍：第{pageRange}頁
              </div>
              <div>
                派卷難度：{ difficultyName(difficulty) }
              </div>
              <div>
                注意事項：請更新頁面以取得最新紀錄
              </div>
            </div>
          </div>
          <div className={styles.infoScore}>
            <div className={styles.score}>
              <div>
                <span className={styles.scoreText}>
                  {total}
                </span>
                <span className={styles.scoreUnit}>
                  人
                </span>  
              </div>
              已交卷人數
            </div>
            <Divider  orientation="vertical" flexItem/>
            <div className={styles.score}>
              <div>
                <span className={styles.scoreText}>
                  {formattedAverageTime}
                </span>
              </div>
              平均花費時長
            </div>
            <Divider  orientation="vertical" flexItem/>
            <div className={styles.score}>
              <div>
                <span className={styles.scoreText}>
                  {info.averageScore}
                </span>
                <span className={styles.scoreUnit}>
                分
                </span>
              </div>
              平均成績
            </div>
          </div>  
        </div>
        <div className={styles.blockBottom}>
          <div className={styles.examTableTitle}>
            <Typography>測驗列表</Typography>
            <div className={styles.updateTimeBlock}>

              <div>最後更新時間：{ updateTime }</div>

              <Button classes={refreshButtonStyles} variant='contained' color="primary" startIcon={<RefreshIcon />} onClick={() => window.location.reload()}>
                更新
              </Button>
            </div>
          </div>
          <TableContainer classes={tableStyles}>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">                            
                            <div className={styles.tableSort} onClick={handleSort}>
                            派出時間
                            <Icon
                              type="text"
                              name={iconName()}
                            />
                            </div></TableCell>
                          <TableCell align="left">座號</TableCell>
                          <TableCell align="left">姓名</TableCell>
                          <TableCell align="left">花費時長</TableCell>
                          <TableCell align="left">成績</TableCell>
                          <TableCell align="left" />
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {
                          data.map((item, index) => (
                            <TableRow key={index}>
                              <TableCell align="left">{dateformat(item.createdAt, 'yyyy/mm/dd HH:MM')}</TableCell>
                              <TableCell align="left">{item.seatNo}</TableCell>
                              <TableCell align="left">{item.userName}</TableCell>
                              <TableCell align="left">{getTimeFormat(item.sumTime)}</TableCell>
                              <TableCell align="left">{item.userTotalScore} 分</TableCell>
                              <TableCell align="right">
                                <Button classes={buttonStyles} variant="contained" color="primary" onClick={() => toExamRecord(item)}>
                                  查看紀錄
                                </Button>
                              </TableCell>
                            </TableRow>
                          ))
                        }
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    component="div"
                    labelRowsPerPage="每頁列數"
                    count={total}
                    rowsPerPage={limit}
                    page={page}
                    onChangePage={(event, _page) => setPage(_page)}
                    onChangeRowsPerPage={event => {
                      setLimit(parseInt(event.target.value, 10));
                      setPage(0);
                    }}
                  />
        </div>  
      </div>
    </div>
    }
    </div>
  );
}